import React from 'react';

import { useConfirmationMemoContext } from '../startup/ConfirmationMemoApp';
import PageFrame from '../../ProfitAndLoss/components/PageFrame';
import ConfirmationMemoReport from './ConfirmationMemoReport';

const ConfirmationMemo = () => {
  const {
    csrfToken,
    team,
    confirm,
    currentUser,
    showPageFrame,
    eventHeader,
    artists,
    ticketsOverview,
    ticketScaling,
    showDetails,
    contacts,
    timeZone,
  } = useConfirmationMemoContext();

  const downloadLinks = [
    {
      href: `/teams/${team.id}/confirms/${confirm.id}/confirmation_memo.pdf`,
      icon: "far fa-file-pdf",
      label: "Download PDF"
    }
  ];

  return (
    <PageFrame
      csrfToken={csrfToken}
      currentUser={currentUser}
      confirm={confirm}
      showPageFrame={showPageFrame}
      team={team}
      downloadLinks={downloadLinks}
    >
      <ConfirmationMemoReport
        confirm={confirm}
        eventHeader={eventHeader}
        artists={artists}
        ticketsOverview={ticketsOverview}
        ticketScaling={ticketScaling}
        showDetails={showDetails}
        contacts={contacts}
        timeZone={timeZone}
      />
    </PageFrame>
  );
};

export default ConfirmationMemo;
